import { Component, type ReactNode } from "react";

import { ErrorBoundary } from "@sentry/react";
import { isAxiosError } from "axios";
import { resetAllSlices } from "src/store/helpers/resetStore.helper";

interface ErrorHandlerProps {
  children: ReactNode;
}

class ErrorHandler extends Component<ErrorHandlerProps> {
  componentDidCatch(error: unknown): void {
    // eslint-disable-next-line no-console
    console.error(error);

    // dont handle errors in dev for debugging
    if (import.meta.env?.DEV) {
      return;
    }

    // dont handle axios Errors
    if (!error || isAxiosError(error)) {
      return;
    }

    // hard refresh on unhandled errors
    if (error instanceof Error) {
      resetAllSlices();
      window.location.reload();
    }
  }

  render(): ReactNode {
    return <ErrorBoundary fallback={<div>Something went wrong</div>}>{this.props.children}</ErrorBoundary>;
  }
}

export default ErrorHandler;
